import { render } from "./ea.vue?vue&type=template&id=2616eac9"
import script from "./ea.vue?vue&type=script&lang=ts"
export * from "./ea.vue?vue&type=script&lang=ts"

import "./ea.vue?vue&type=style&index=0&id=2616eac9&lang=css"
script.render = render

export default script